<template>
  <div class="container-xxl">
    <TituloGrande texto="Configurações gerais" posicao="left" />

    <fieldset>
      <div class="col-10 col-md-8 offset-1 offset-md-2 mb-5 shadow p-4 rounded-3">
        <div class="row">
          <InputText classDiv="col-md-12" label="Vídeo abertura" tamanho="sm" nome="video_youtube_home" ref="video_youtube_home"
            :ativa_placeholder="load_dados" v-model="dados.video_youtube_home" />
          <InputText classDiv="col-md-12" label="Vídeo podcast" tamanho="sm" nome="video_podcast_home" ref="video_podcast_home"
            :ativa_placeholder="load_dados" v-model="dados.video_podcast_home" />

          <div class="col-12 fw-bold fs-4 text-center">
            Termos de uso
          </div>
          <InputEditor name="conteudo" class="form-control" v-model="dados.termos_de_uso" />

          <button class="text-center btn btn-bg btn-info text-light" @click="salvar">Salvar alterações</button>
        </div>
      </div>
    </fieldset>
    
  </div>
</template>

<script>
import { bloqueia_campos } from '@/assets/js/functions';
import InputEditor from '@/components/form/InputEditor.vue';
import InputText from '@/components/form/InputText.vue';
import TituloGrande from '@/components/TituloGrande.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';

export default {
  name: 'ConfigGeral',
  props: {
  },
  components: {
    TituloGrande,
    InputText,
    InputEditor,
  },
  data() {
    return {
      auth: AuthStore(),
      dados: '',
      load_dados: false,
    }
  },
  methods: {
    async carrega_dados() {
      this.dados = await api.get('admin/config_general');      
      this.load_dados = false
    },
    async salvar() {
      this.load_dados = true
      bloqueia_campos()
      try {
        const data = await api.post('admin/save_config_general', this.dados, { Authorization: this.auth.token })
        
        if (data.status == 200) {
          toastr.sucesso("Dados atualizados com sucesso.")
          this.auth.renewToken()
        } else {
          toastr.erro(data.message)
        }
      } catch (error) {
        toastr.erro(error)
      }
      this.load_dados = false
      bloqueia_campos(false)
    },
  },
  mounted() {
    this.carrega_dados()
  },
}
</script>

<style scoped>

</style>